import Marquee from "react-fast-marquee";

const ITEMS = [
    "Website Design",
    "Digital Marketing",
    "Business Automation",
    "Brand Systems",
    "Lead Pipelines",
    "Product Launches",
];

export const EditorialMarquee = () => (
    <div
        data-testid="editorial-marquee"
        className="overflow-hidden border-y border-white/10 py-8 md:py-12"
    >
        <Marquee speed={32} gradient={false} pauseOnHover={false}>
            {ITEMS.map((item) => (
                <span key={item} className="flex items-center">
                    <span className="mx-10 font-display text-4xl font-bold uppercase tracking-tight text-white/15 md:mx-16 md:text-6xl">
                        {item}
                    </span>
                    <span className="text-xl text-white/25 md:text-2xl">✦</span>
                </span>
            ))}
        </Marquee>
    </div>
);
